<template>
  <div>
    <div class="current-position">
      <img class="app-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="app-container">
          <div class="current-position-logotext">Science Popularization</div>
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="justify-between">
        <div class="survey-module-right" v-show="!detail_show">
          <div class="survey-module-right-title f-w">
            {{ menu.title }}
          </div>
          <div class="survey-module-right-action">
            <div class="new-list" v-if="menu_action.length>0">
              <div class="new-item justify-between" v-for="(item,index) in menu_action" :key="index" @click="openDetail(item)">
                <div class="new-item-img-box">
                  <img :src="$baseUrl+item.thumbnailUrl" alt="">
                </div>
                <div class="new-item-content flex-col justify-between">
                  <span class="new-item-content-title">{{ item.title }}</span>
                  <span>{{ item.address }}</span>
                  <!-- <span>{{ item.startTime}} ~ {{ item.endTime}}</span> -->
                </div> 
              </div>
              <div class="pagination-content justify-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  :pager-count="5"
                  layout="prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
            </div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
        <div class="survey-module-right" v-show="detail_show">
          <div class="survey-module-right-title f-w justify-between">
            <span>{{ detail_obj.title }}</span>
            <div class="justify-center align-center" @click="detail_show = false">返回</div>
          </div>
          <div class="survey-module-right-action">
            <div class="new-detail" v-html="detail_obj.content" v-if="detail_obj.content"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getList,getDeatil} from "@/api/wzgl";
export default {
  data(){
    return{
      menu:{
        title:'科学普及',
      },
      menu_id:1,
      menu_action:[],
      queryParams:{
        pageNum: 1,
        pageSize: 10,
        type:'science'
      },
      total:0,
      // 详情
      detail_show:false,
      detail_obj:{
        title:'',
        content:'',
        createTime:''
      }
    }
  },
  created(){
    this.menuFun(this.$route.query.id)
    if('detail_id' in this.$route.query){
      getDeatil({id:this.$route.query.detail_id})
      .then((res)=>{
        if(res.code==200){
          this.detail_obj = res.data
          this.detail_obj.content = this.detail_obj.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
          this.detail_obj.content = this.detail_obj.content.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
          this.detail_show = true
        }
      })
    }
  },
  methods:{
    menuFun(id){
      this.menu_id = id
      this.queryParams.pageNum = 1
      this.detail_show = false
      this.getFun()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.getFun()
    },
    getFun(){
      getList(this.queryParams)
      .then(({ data }) => {
        this.menu_action = data.list;
        this.total = data.total;
      })
      .finally(() => {});
    },
    openDetail(row){
      this.detail_show = true
      this.detail_obj = row
      window.scrollTo(0,0);
    }
  }
}
</script>
<style scoped lang="css" src="../assets/css/base.css" />
<style scoped>

</style>
